import { render, staticRenderFns } from "./ChnlMoveAssetDlg.vue?vue&type=template&id=200705f2"
import script from "./ChnlMoveAssetDlg.vue?vue&type=script&lang=js"
export * from "./ChnlMoveAssetDlg.vue?vue&type=script&lang=js"
import style0 from "./ChnlMoveAssetDlg.vue?vue&type=style&index=0&id=200705f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports